/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CountryGetAllResp } from '../models/country-get-all-resp';

@Injectable({
  providedIn: 'root',
})
export class CountryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation countryGetAll
   */
  static readonly CountryGetAllPath = '/country';

  /**
   * Countries
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<CountryGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, CountryService.CountryGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CountryGetAllResp>;
      })
    );
  }

  /**
   * Countries
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `countryGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryGetAll(params?: {
  }): Observable<CountryGetAllResp> {

    return this.countryGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<CountryGetAllResp>) => r.body as CountryGetAllResp)
    );
  }

}
